import { Directive, EventEmitter, HostListener, inject, Input, Output } from '@angular/core';
import { MessageService } from 'primeng/api';

@Directive({
    selector: '[appCopyToClipboard]',
    standalone: true,
})
export class CopyToClipboardDirective {
    @Input() appCopyToClipboard: string | null | undefined;
    @Output() copied = new EventEmitter<boolean>();
    readonly _messageService = inject(MessageService);

    @HostListener('click')
    async onClick(): Promise<void> {
        const value = this.appCopyToClipboard ?? '';
        const copied = await this.copyText(value);
        this.copied.emit(copied);
        if (copied) {
            this._messageService.add({ severity: 'success', summary: 'Copied', detail: 'Text copied to clipboard' });
        } else {
            this._messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to copy text' });
        }
    }

    private async copyText(value: string): Promise<boolean> {
        if (!value.trim()) {
            return false;
        }

        if (window.isSecureContext && navigator.clipboard?.writeText) {
            try {
                await navigator.clipboard.writeText(value);
                return true;
            } catch {
                // Fallback to execCommand when async clipboard is blocked.
            }
        }

        const textarea = document.createElement('textarea');
        textarea.value = value;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        textarea.style.pointerEvents = 'none';

        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();

        const successful = document.execCommand('copy');
        document.body.removeChild(textarea);

        return successful;
    }
}
